"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/divider/style/css");
var divider_1 = __importDefault(require("antd/lib/divider"));
require("antd/lib/form/style/css");
var form_1 = __importDefault(require("antd/lib/form"));
require("antd/lib/input/style/css");
var input_1 = __importDefault(require("antd/lib/input"));
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _objectDestructuringEmpty(t) { if (null == t)
    throw new TypeError("Cannot destructure " + t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
} return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var HTMLEditor_1 = __importDefault(require("../editor/HTMLEditor"));
var ObjectForm_1 = __importStar(require("../ObjectForm"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var REVISION_MESSAGE_PATH = ["revision", "message"];
var transformInitialValues = function transformInitialValues(v) {
    var _v$revision$number, _v$revision;
    return _objectSpread(_objectSpread({
        close_text: "Close"
    }, v), {}, {
        revision: {
            working_copy: (_v$revision$number = (_v$revision = v.revision) === null || _v$revision === void 0 ? void 0 : _v$revision.number) !== null && _v$revision$number !== void 0 ? _v$revision$number : null,
            message: "" // Clear revision message for possible filling out & re-submission
        }
    });
};
var ModalForm = function ModalForm(_ref) {
    var _transformedInitialVa;
    var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var navigate = (0, react_router_dom_1.useNavigate)();
    var quillRef = (0, react_1.useRef)(undefined);
    var transformFinalValues = (0, react_1.useCallback)(function (v) {
        return _objectSpread(_objectSpread({}, v), {}, {
            content: quillRef.current.getEditor().root.innerHTML
        });
    }, [quillRef]);
    var onView = (0, react_1.useCallback)(function (v) {
        if (!v.id)
            return;
        navigate("/modals/detail/".concat(v.id), {
            replace: true
        });
    }, [navigate]);
    var objectForm = (0, ObjectForm_1.useObjectForm)(_objectSpread({
        transformInitialValues: transformInitialValues,
        transformFinalValues: transformFinalValues,
        onView: onView
    }, props));
    var transformedInitialValues = objectForm.transformedInitialValues;
    return (0, jsx_runtime_1.jsxs)(ObjectForm_1.default, _objectSpread(_objectSpread({
        objectForm: objectForm
    }, props), {}, {
        children: [(0, jsx_runtime_1.jsx)(form_1.default.Item, {
                name: "title",
                label: "Title",
                rules: ObjectForm_1.RULES_REQUIRED_BASIC,
                children: (0, jsx_runtime_1.jsx)(input_1.default, {})
            }), (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                name: "close_text",
                label: "Close Button Text",
                rules: ObjectForm_1.RULES_REQUIRED_BASIC,
                children: (0, jsx_runtime_1.jsx)(input_1.default, {})
            }), (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                label: "Content",
                children: (0, jsx_runtime_1.jsx)(HTMLEditor_1.default, {
                    initialValue: (_transformedInitialVa = transformedInitialValues.content) !== null && _transformedInitialVa !== void 0 ? _transformedInitialVa : "",
                    innerRef: quillRef
                })
            }), (0, jsx_runtime_1.jsx)(divider_1.default, {}), (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                name: REVISION_MESSAGE_PATH,
                label: "Revision Message",
                children: (0, jsx_runtime_1.jsx)(input_1.default, {})
            })]
    }));
};
exports.default = ModalForm;
